export function toggleRequiredAttributes(fields, requiredFlag) {
  fields.prop('required', requiredFlag);
}